import { AutomationsState, automationsReducer } from '@spike/automations-action';
import { ActivitiesState, activitiesReducer } from '@spike/activities-action';
import { AddOnServicesState, addOnServicesReducer } from '@spike/addon-services-action';
import { BelongingsState, belongingsReducer } from '@spike/belongings-action';
import { AvailableStaffState, availableStaffReducer } from '@spike/available-staff-action';
import { BlockCalendarState, blockCalendarReducer } from '@spike/block-calendar-action';
import { AppointmentsState, BookingsState, appointmentsReducer, bookingsReducer } from '@spike/bookings-action';
import { AppointmentsListState, appointmentsListReducer } from '@spike/appointments-list-action';
import { ClientsState, clientsReducer } from '@spike/clients-action';
import { CommissionsState, commissionsReducer } from '@spike/commissions-action';
import {
    CustomContentNotificationReducer,
    CustomContentNotificationState
} from '@spike/custom-content-notification-action';
import {
    EmailCampaignsState,
    EmailMarketingSenderState,
    EmailTemplatesState,
    emailCampaignsReducer,
    emailMarketingSenderReducer,
    emailTemplatesReducer
} from '@spike/email-marketing-action';
import { ForgotPasswordState, forgotPasswordReducer } from '@spike/forgot-password-action';
import { InvoicesState, invoicesReducer } from '@spike/invoices-action';
import { MarketplaceState, marketplaceReducer } from '@spike/marketplace-action';
import { MasterDataState, masterDataReducer } from '@spike/masterdata-action';
import { MembershipsState, membershipsReducer } from '@spike/memberships-action';
import {
    NewBookingsState as NewBookingState,
    newBookingsReducer as newBookingReducer
} from '@spike/new-bookings-action';
import { NotificationsState, notificationsMiddleware, notificationsReducer } from '@spike/notifications-action';
import { OmnichannelState } from '@spike/omnichannel-action';
import { omnichannelReducer } from 'reducers/omnichannel/omnichannelReducer';
import { OrdersState, ordersReducer } from '@spike/orders-action';
import { PaymentsState, paymentsReducer } from '@spike/payments-action';
import { PetsState, petsReducer } from '@spike/pets-action';
import { PosState, posReducer } from '@spike/pos-action';
import { ProductsState, productsReducer } from '@spike/products-action';
import { SingleSalesState, singleSalesReducer } from '@spike/single-sales-action';
import { TerminalsState, terminalsReducer } from '@spike/terminals-action';
import { VetsState, vetsReducer } from '@spike/vets-action';
import { WalletsState, walletsReducer } from '@spike/wallets-action';
import { RootAction } from 'actions/ActionTypes';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import activateAccountReducer from 'reducers/activateAccount/ActivateAccountReducer';
import { ActivateAccountState } from 'reducers/activateAccount/ActivateAccountState';
import { agreementsReducer } from 'reducers/agreements/AgreementsReducer';
import { AgreementsState } from 'reducers/agreements/AgreementsState';
import { AppointmentsDetailReportReducer } from 'reducers/appointmentsDetailReport/AppointmentsDetailReportReducer';
import { AppointmentsDetailReportState } from 'reducers/appointmentsDetailReport/AppointmentsDetailReportState';
import { autocompleteReducer } from 'reducers/autocomplete/AutocompleteReducer';
import { AutocompleteState } from 'reducers/autocomplete/AutocompleteState';
import { availabilityReducer } from 'reducers/availability/AvailabilityReducer';
import { AvailabilityState } from 'reducers/availability/AvailabilityState';
import bookingAttemptsReducer from 'reducers/bookingAttempts/BookingAttemptsReducer';
import { BookingAttemptsState } from 'reducers/bookingAttempts/BookingAttemptsState';
import waitlistsReducer from 'reducers/waitlists/WaitlistsReducer';
import { WaitlistsState } from 'reducers/waitlists/WaitlistsState';
import { BookingsInsightsReportReducer } from 'reducers/bookingsInsightsReport/BookingsInsightsReportReducer';
import { BookingsInsightsReportState } from 'reducers/bookingsInsightsReport/BookingsInsightsReportState';
import { BookingsSummaryReportReducer } from 'reducers/bookingsSummaryReport/BookingsSummaryReportReducer';
import { BookingsSummaryReportState } from 'reducers/bookingsSummaryReport/BookingsSummaryReportState';
import BusinessSettingsReducer from 'reducers/businessSettings/BusinessSettingsReducer';
import BusinessSettingsSidebarReducer from 'reducers/businessSettings/BusinessSettingsSidebarReducer';
import { BusinessSettingsSidebarState } from 'reducers/businessSettings/BusinessSettingsSidebarState';
import { PetTypeStatusState } from 'reducers/businessSettings/PetTypeStatusState';
import { ClientInsightsReportReducer } from 'reducers/clientInsightsReport/ClientInsightsReportReducer';
import { ClientInsightsReportState } from 'reducers/clientInsightsReport/ClientInsightsReportState';
import { ClientReportReducer } from 'reducers/clientReport/ClientReportReducer';
import { ClientReportState } from 'reducers/clientReport/ClientReportState';
import globalSearchReducer from 'reducers/globalSearch/GlobalSearchReducer';
import { GlobalSearchState } from 'reducers/globalSearch/GlobalSearchState';
import loginReducer from 'reducers/login/LoginReducer';
import { LoginState } from 'reducers/login/LoginState';
import menuReducer from 'reducers/menu/MenuReducer';
import { MenuState } from 'reducers/menu/MenuState';
import MyAccountSidebarReducer from 'reducers/myAccount/MyAccountSidebarReducer';
import { MyAccountSidebarState } from 'reducers/myAccount/MyAccountSidebarState';
import { newBookingsReducer } from 'reducers/newBookings/NewBookingsReducer';
import { NewBookingsState } from 'reducers/newBookings/NewBookingsState';
import { newFeaturesReducer } from 'reducers/newFeatures/NewFeaturesReducer';
import { NewFeaturesState } from 'reducers/newFeatures/NewFeaturesState';
import notificationBellReducer from 'reducers/notificationBell/NotificationBellReducer';
import { NotificationBellState } from 'reducers/notificationBell/NotificationBellState';
import onboardingStepsReducer from 'reducers/onboardingSettings/onboardingStepsReducer';
import { OnboardingStepsState } from 'reducers/onboardingSettings/onboardingStepsState';
import { emailUnsubscribeReducer } from 'reducers/emailUnsubscribe/EmailUnsubscribeReducer';
import { EmailUnsubscribeState } from 'reducers/emailUnsubscribe/EmailUnsubscribeState';
import { payByLinkReducer } from 'reducers/payByLink/payByLinkReducer';
import { PayByLinkState } from 'reducers/payByLink/payByLinkState';
import { BirthdayReportReducer } from 'reducers/petBirthdayReport/BirthdayReportReducer';
import { BirthdayReportState } from 'reducers/petBirthdayReport/BirthdayReportState';
import { PetBreakdownReportReducer } from 'reducers/petBreakdownReport/PetBreakdownReportReducer';
import { PetBreakdownReportState } from 'reducers/petBreakdownReport/PetBreakdownReportState';
import { PhoneSearchReducer } from 'reducers/phoneSearch/phoneSearchReducer';
import { PhoneSearchState } from 'reducers/phoneSearch/phoneSearchState';
import { productCategoriesReducer } from 'reducers/productCategories/ProductCategoriesReducer';
import { ProductCategoriesState } from 'reducers/productCategories/ProductCategoriesState';
import { productVendorsReducer } from 'reducers/productVendors/ProductVendorsReducer';
import { ProductVendorsState } from 'reducers/productVendors/ProductVendorsState';
import { prospectMessageReducer } from 'reducers/prospectMessage/prospectMessageReducer';
import { ProspectMessageState } from 'reducers/prospectMessage/prospectMessageState';
import { reportsReducer } from '@spike/reports-action';
import { ReportsState } from '@spike/reports-action';
import resetPasswordReducer from 'reducers/resetPassword/ResetPasswordReducer';
import { ResetPasswordState } from 'reducers/resetPassword/ResetPasswordState';
import { revenuesReducer } from 'reducers/revenues/RevenuesReducer';
import { RevenuesState } from 'reducers/revenues/RevenuesState';
import { servicesReducer } from 'reducers/services/ServicesReducer';
import { ServicesState } from 'reducers/services/ServicesState';
import signUpReducer from 'reducers/signUp/SignUpReducer';
import { SignUpState } from 'reducers/signUp/SignUpState';
import smsCampaignsReducer from 'reducers/smsCampaigns/SMSCampaignsReducer';
import { SMSCampaignsState } from 'reducers/smsCampaigns/SMSCampaignsState';
import { staffReducer } from 'reducers/staff/StaffReducer';
import { StaffState } from 'reducers/staff/StaffState';
import { serviceSessionsReducer } from 'reducers/serviceSessions/ServiceSessionsReducer';
import { ServiceSessionsState } from 'reducers/serviceSessions/ServiceSessionsState';
import { opsTasksReducer } from 'reducers/opsTasks/OpsTasksReducer';
import { OpsTasksState } from 'reducers/opsTasks/OpsTasksState';
import subscriptionsReducer from 'reducers/subscriptions/SubscriptionsReducer';
import { SubscriptionsState } from 'reducers/subscriptions/SubscriptionsState';
import { TipsReportReducer } from 'reducers/tipsReport/TipsReportReducer';
import { TipsReportState } from 'reducers/tipsReport/TipsReportState';
import twoWaySmsReducer from 'reducers/twowaysms/TwoWaySmsReducer';
import { TwoWaySmsState } from 'reducers/twowaysms/TwoWaySmsState';
import { UpdateExpiredVaccinesReducer } from 'reducers/updateExpiredVaccines/UpdateExpiredVaccinesReducer';
import { UpdateExpiredVaccinesState } from 'reducers/updateExpiredVaccines/UpdateExpiredVaccinesState';
import userNotificationsReducer from 'reducers/userNotifications/UserNotificationsReducer';
import { UserNotificationsState } from 'reducers/userNotifications/UserNotificationsState';
import { usersReducer } from 'reducers/users/UsersReducer';
import { UsersState } from 'reducers/users/UsersState';
import { VaccineReportReducer } from 'reducers/vaccineReport/VaccineReportReducer';
import { VaccineReportState } from 'reducers/vaccineReport/VaccineReportState';
import { Store, applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk, { ThunkDispatch } from 'redux-thunk';
import bulkUploadReducer from './reducers/bulkUpload/BulkUploadReducer';
import { BulkUploadState } from './reducers/bulkUpload/BulkUploadState';
import { RoomsState } from '@spike/rooms-action';
import { roomsReducer } from '@spike/rooms-action';
import { VehiclesState, vehiclesReducer } from '@spike/vehicles-action';
import { reviewsReducer, ReviewsState } from '@spike/reviews-action';
import { FormsReducer, FormsState } from '@spike/forms-action';
import { vaccineApprovalsReducer, VaccineApprovalsState } from '@spike/vaccine-approvals-action';
import { tasksReducer, TasksState } from '@spike/tasks-action';
import { PromocodesState, promocodesReducer } from '@spike/promocodes-action';
import { DiscountsState, discountsReducer } from '@spike/discounts-action';
import { LoyaltyState, loyaltyReducer } from '@spike/loyalty-action';
import dataExportReducer from 'reducers/dataExport/DataExportReducer';
import { DataExportState } from 'reducers/dataExport/DataExportState';
import {
    dealsReducer,
    DealsState,
    ratesReducer,
    RatesState,
    rateRulesReducer,
    RateRulesState
} from '@spike/boarding-rules-action';
import { WeeklyBreakdownReportState } from 'reducers/weeklyBreakdownReport/WeeklyBreakdownReportState';
import { WeeklyBreakdownReportReducer } from 'reducers/weeklyBreakdownReport/WeeklyBreakdownReportReducer';
import { MonthlyBreakdownReportState } from 'reducers/monthlyBreakdownReport/MonthlyBreakdownReportState';
import { MonthlyBreakdownReportReducer } from 'reducers/monthlyBreakdownReport/MonthlyBreakdownReportReducer';
import { MonthlyNetSalesReportState } from 'reducers/monthlyNetSalesReport/MonthlyNetSalesReportState';
import { monthlyNetSalesReportReducer } from 'reducers/monthlyNetSalesReport/MonthlyNetSalesReportReducer';
import { CancellationAndNoShowsReportState } from 'reducers/cancellationAndNoShowsReport/CancellationAndNoShowsReportState';
import { CancellationAndNoShowsReportReducer } from 'reducers/cancellationAndNoShowsReport/CancellationAndNoShowsReportReducer';
import { RoomsOperatingReportState } from 'reducers/roomsOperatingReport/RoomsOperatingReportState';
import RoomsOperatingReportReducer from 'reducers/roomsOperatingReport/RoomsOperatingReportReducer';
import { TransactionsReportState } from 'reducers/transactionsReport/TransactionsReportState';
import TransactionsReportReducer from 'reducers/transactionsReport/TransactionsReportReducer';
import { SalesByCategoryReportState } from 'reducers/salesByCategoryReport/SalesByCategoryReportState';
import { salesByCategoryReportReducer } from 'reducers/salesByCategoryReport/SalesByCategoryReportReducer';
import { ServicesInsightsReportState } from 'reducers/servicesInsightsReport/ServicesInsightsReportState';
import { servicesInsightsReportReducer } from 'reducers/servicesInsightsReport/ServicesInsightsReportReducer';
import { AddonsInsightsReportState } from 'reducers/addonsInsightsReport/AddonsInsightsReportState';
import { addonsInsightsReportReducer } from 'reducers/addonsInsightsReport/AddonsInsightsReportReducer';
import { ProductsInsightsReportState } from 'reducers/productsInsightsReport/ProductsInsightsReportState';
import productsInsightsReportReducer from 'reducers/productsInsightsReport/ProductsInsightsReportReducer';
import { TaxListDetailReportState } from 'reducers/taxListDetailReport/TaxListDetailReportState';
import { TaxListDetailReportReducer } from 'reducers/taxListDetailReport/TaxListDetailReportReducer';
import { CustomItemsInsightsReportState } from 'reducers/customItemsInsightsReport/CustomItemsInsightsReportState';
import { customItemsInsightsReportReducer } from 'reducers/customItemsInsightsReport/CustomItemsInsightsReportReducer';

export const history = createBrowserHistory();

export interface RootState {
    readonly onboardingSteps: OnboardingStepsState;
    readonly login: LoginState;
    readonly menu: MenuState;
    readonly forgotPassword: ForgotPasswordState;
    readonly signUp: SignUpState;
    readonly resetPassword: ResetPasswordState;
    readonly activateAccount: ActivateAccountState;
    readonly BusinessSettingsSidebar: BusinessSettingsSidebarState;
    readonly MyAccountSidebar: MyAccountSidebarState;
    readonly marketplace: MarketplaceState;
    readonly masterData: MasterDataState;
    readonly services: ServicesState;
    readonly petTypeStatus: PetTypeStatusState;
    readonly addOnServices: AddOnServicesState;
    readonly staff: StaffState;
    readonly serviceSessions: ServiceSessionsState;
    readonly opsTasks: OpsTasksState;
    readonly appointments: AppointmentsState;
    readonly bookings: BookingsState;
    readonly appointmentsList: AppointmentsListState;
    readonly globalSearch: GlobalSearchState;
    readonly newBookingsOld: NewBookingsState;
    readonly invoices: InvoicesState;
    readonly reports: ReportsState;
    readonly clients: ClientsState;
    readonly memberships: MembershipsState;
    readonly pets: PetsState;
    readonly belongings: BelongingsState;
    readonly availableStaff: AvailableStaffState;
    readonly availability: AvailabilityState;
    readonly revenues: RevenuesState;
    readonly users: UsersState;
    readonly subscriptions: SubscriptionsState;
    readonly autocomplete: AutocompleteState;
    readonly notifications: NotificationsState;
    readonly newFeatures: NewFeaturesState;
    readonly products: ProductsState;
    readonly pos: PosState;
    readonly productCategories: ProductCategoriesState;
    readonly productVendors: ProductVendorsState;
    readonly vets: VetsState;
    readonly payments: PaymentsState;
    readonly singleSales: SingleSalesState;
    readonly terminals: TerminalsState;
    readonly notificationBell: NotificationBellState;
    readonly userNotifications: UserNotificationsState;
    readonly omnichannel: OmnichannelState;
    readonly twoWaySms: TwoWaySmsState;
    readonly smsCampaigns: SMSCampaignsState;
    readonly agreements: AgreementsState;
    readonly bulkUpload: BulkUploadState;
    readonly tipsReport: TipsReportState;
    readonly newBookings: NewBookingState;
    readonly blockCalendar: BlockCalendarState;
    readonly commissions: CommissionsState;
    readonly payByLink: PayByLinkState;
    readonly emailUnsubscribe: EmailUnsubscribeState;
    readonly orders: OrdersState;
    readonly rooms: RoomsState;
    readonly vehicles: VehiclesState;
    readonly clientReport: ClientReportState;
    readonly vaccineReport: VaccineReportState;
    readonly birthdayReport: BirthdayReportState;
    readonly petBreakdownReport: PetBreakdownReportState;
    readonly insightReport: ClientInsightsReportState;
    readonly updateVaccines: UpdateExpiredVaccinesState;
    readonly prospectMessages: ProspectMessageState;
    readonly phoneSearch: PhoneSearchState;
    readonly bookingAttempts: BookingAttemptsState;
    readonly waitlists: WaitlistsState;
    readonly bookingsSummaryReport: BookingsSummaryReportState;
    readonly appointmentsDetailReport: AppointmentsDetailReportState;
    readonly customContentNotifications: CustomContentNotificationState;
    readonly emailTemplates: EmailTemplatesState;
    readonly emailCampaigns: EmailCampaignsState;
    readonly emailMarketingSender: EmailMarketingSenderState;
    readonly bookingsInsightsReport: BookingsInsightsReportState;
    readonly activities: ActivitiesState;
    readonly reviews: ReviewsState;
    readonly tasks: TasksState;
    readonly promocodes: PromocodesState;
    readonly discounts: DiscountsState;
    readonly loyalty: LoyaltyState;
    readonly forms: FormsState;
    readonly vaccineApprovals: VaccineApprovalsState;
    readonly dataExport: DataExportState;
    readonly deals: DealsState;
    readonly weeklyBreakdownReport: WeeklyBreakdownReportState;
    readonly monthlyBreakdownReport: MonthlyBreakdownReportState;
    readonly monthlyNetSalesReport: MonthlyNetSalesReportState;
    readonly cancellationAndNoShowsReport: CancellationAndNoShowsReportState;
    readonly roomsOperatingReport: RoomsOperatingReportState;
    readonly transactionsReport: TransactionsReportState;
    readonly salesByCategoryReport: SalesByCategoryReportState;
    readonly servicesInsightsReport: ServicesInsightsReportState;
    readonly addonsInsightsReport: AddonsInsightsReportState;
    readonly productsInsightsReport: ProductsInsightsReportState;
    readonly taxListDetailReport: TaxListDetailReportState;
    readonly rates: RatesState;
    readonly rateRules: RateRulesState;
    readonly customItemsInsightsReport: CustomItemsInsightsReportState;
    readonly automations: AutomationsState;
    readonly wallets: WalletsState;
}
// eslint-disable-next-line
const createRootReducer = (history: any) =>
    combineReducers({
        router: connectRouter(history),
        login: loginReducer,
        menu: menuReducer,
        forgotPassword: forgotPasswordReducer,
        signUp: signUpReducer,
        resetPassword: resetPasswordReducer,
        activateAccount: activateAccountReducer,
        BusinessSettingsSidebar: BusinessSettingsSidebarReducer,
        MyAccountSidebar: MyAccountSidebarReducer,
        onboardingSteps: onboardingStepsReducer,
        marketplace: marketplaceReducer,
        masterData: masterDataReducer,
        services: servicesReducer,
        petTypeStatus: BusinessSettingsReducer,
        addOnServices: addOnServicesReducer,
        staff: staffReducer,
        serviceSessions: serviceSessionsReducer,
        opsTasks: opsTasksReducer,
        appointments: appointmentsReducer,
        globalSearch: globalSearchReducer,
        bookings: bookingsReducer,
        appointmentsList: appointmentsListReducer,
        newBookingsOld: newBookingsReducer,
        invoices: invoicesReducer,
        reports: reportsReducer,
        clients: clientsReducer,
        memberships: membershipsReducer,
        pets: petsReducer,
        belongings: belongingsReducer,
        availableStaff: availableStaffReducer,
        availability: availabilityReducer,
        revenues: revenuesReducer,
        users: usersReducer,
        subscriptions: subscriptionsReducer,
        autocomplete: autocompleteReducer,
        notifications: notificationsReducer,
        newFeatures: newFeaturesReducer,
        products: productsReducer,
        pos: posReducer,
        productCategories: productCategoriesReducer,
        productVendors: productVendorsReducer,
        vets: vetsReducer,
        payments: paymentsReducer,
        singleSales: singleSalesReducer,
        terminals: terminalsReducer,
        notificationBell: notificationBellReducer,
        userNotifications: userNotificationsReducer,
        omnichannel: omnichannelReducer,
        twoWaySms: twoWaySmsReducer,
        smsCampaigns: smsCampaignsReducer,
        agreements: agreementsReducer,
        bulkUpload: bulkUploadReducer,
        tipsReport: TipsReportReducer,
        newBookings: newBookingReducer,
        blockCalendar: blockCalendarReducer,
        commissions: commissionsReducer,
        payByLink: payByLinkReducer,
        emailUnsubscribe: emailUnsubscribeReducer,
        orders: ordersReducer,
        rooms: roomsReducer,
        vehicles: vehiclesReducer,
        clientReport: ClientReportReducer,
        vaccineReport: VaccineReportReducer,
        birthdayReport: BirthdayReportReducer,
        petBreakdownReport: PetBreakdownReportReducer,
        insightReport: ClientInsightsReportReducer,
        updateVaccines: UpdateExpiredVaccinesReducer,
        prospectMessages: prospectMessageReducer,
        phoneSearch: PhoneSearchReducer,
        bookingAttempts: bookingAttemptsReducer,
        waitlists: waitlistsReducer,
        bookingsSummaryReport: BookingsSummaryReportReducer,
        appointmentsDetailReport: AppointmentsDetailReportReducer,
        customContentNotifications: CustomContentNotificationReducer,
        emailTemplates: emailTemplatesReducer,
        emailCampaigns: emailCampaignsReducer,
        emailMarketingSender: emailMarketingSenderReducer,
        bookingsInsightsReport: BookingsInsightsReportReducer,
        activities: activitiesReducer,
        tasks: tasksReducer,
        promocodes: promocodesReducer,
        discounts: discountsReducer,
        loyalty: loyaltyReducer,
        reviews: reviewsReducer,
        forms: FormsReducer,
        vaccineApprovals: vaccineApprovalsReducer,
        dataExport: dataExportReducer,
        deals: dealsReducer,
        rates: ratesReducer,
        rateRules: rateRulesReducer,
        weeklyBreakdownReport: WeeklyBreakdownReportReducer,
        monthlyBreakdownReport: MonthlyBreakdownReportReducer,
        monthlyNetSalesReport: monthlyNetSalesReportReducer,
        cancellationAndNoShowsReport: CancellationAndNoShowsReportReducer,
        roomsOperatingReport: RoomsOperatingReportReducer,
        transactionsReport: TransactionsReportReducer,
        salesByCategoryReport: salesByCategoryReportReducer,
        servicesInsightsReport: servicesInsightsReportReducer,
        addonsInsightsReport: addonsInsightsReportReducer,
        productsInsightsReport: productsInsightsReportReducer,
        taxListDetailReport: TaxListDetailReportReducer,
        customItemsInsightsReport: customItemsInsightsReportReducer,
        automations: automationsReducer,
        wallets: walletsReducer
    });

const middleware = applyMiddleware(thunk, routerMiddleware(history), notificationsMiddleware);

const composeEnhancers = composeWithDevTools({});

export const store: Store<RootState, RootAction> = createStore(
    createRootReducer(history),
    composeEnhancers(middleware)
);

export default store;

export const dispatch: ThunkDispatch<RootState, null, RootAction> = store.dispatch;
